import { Link } from "react-router-dom";
import type { AnimeRole } from "@/types";
import Tag from "@/components/base/Tag";
import FavoriteButton from "@/components/base/FavoriteButton";

interface RoleCardProps {
  role: AnimeRole;
}

export default function RoleCard({ role }: RoleCardProps) {
  return (
    <Link
      to={`/role/${role.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={role.cover}
          alt={`${role.name}·${role.work} 萝莉动漫角色立绘`}
          title={`${role.name} 萝莉角色 · ${role.work}`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute right-3 top-3">
          <FavoriteButton type="role" id={role.id} size="sm" />
        </div>
        {role.isNew && (
          <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-medium text-background-50">
            新角色
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/70 to-transparent px-4 pb-3 pt-8">
          <p className="flex items-center gap-1 text-xs text-background-100/90">
            <i className="ri-book-2-line"></i>
            {role.work}
          </p>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base text-foreground-950 transition-colors group-hover:text-primary-600">
          {role.name}
        </h3>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {role.description}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {role.tags.slice(0, 3).map((t) => (
            <Tag key={t} tone="secondary">
              {t}
            </Tag>
          ))}
        </div>
      </div>
    </Link>
  );
}